/*
 * Keeps the header cart count (#cart-icon-bubble) in sync with Slide Cart.
 *
 * The theme only refreshes the bubble on page load and on its own product-form
 * adds. Removals, quantity changes and upsell adds happen inside Slide Cart,
 * which only updates [data-cart-count] elements, so the bubble goes stale.
 * Slide Cart calls window.SLIDECART_UPDATED(cart) after every cart change; we
 * use it to re-render the bubble via the Section Rendering API, the same way
 * product-form.js does.
 *
 * Also moves the Gibby's bundle widget forms off Slide Cart's add-to-cart
 * selector so bundle adds aren't hijacked (see excludeBundleFormsFromSlideCart).
 *
 * Load from layout/theme.liquid:
 *   <script src="{{ 'gibbys-cart-count-sync.js' | asset_url }}" defer></script>
 */
(function () {
  var SECTION_ID = "cart-icon-bubble";
  var requestId = 0;

  function refreshCartBubble() {
    var bubble = document.getElementById(SECTION_ID);
    if (!bubble) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var thisRequest = ++requestId;

    fetch(root + "?sections=" + SECTION_ID)
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        if (thisRequest !== requestId || !sections || sections[SECTION_ID] == null) return;
        // The Section Rendering API wraps output in <div class="shopify-section">.
        // Insert only the inner markup so we don't nest a section inside the header.
        var doc = new DOMParser().parseFromString(sections[SECTION_ID], "text/html");
        var wrapper = doc.querySelector(".shopify-section");
        bubble.innerHTML = wrapper ? wrapper.innerHTML : sections[SECTION_ID];
      })
      .catch(function (error) { console.warn("Cart count sync failed:", error); });
  }

  var previousHandler = window.SLIDECART_UPDATED;
  window.SLIDECART_UPDATED = function (cart) {
    if (typeof previousHandler === "function") previousHandler(cart);
    refreshCartBubble();
  };

  // Slide Cart hijacks submit clicks in any form whose action ends in "/cart/add"
  // and posts it without the bundle's (disabled) variant ids, which fails with
  // "Required parameter missing or invalid: id". The bundle widget builds its own
  // request, so moving its forms off that selector lets the widget handle the add.
  function excludeBundleFormsFromSlideCart() {
    document.querySelectorAll("form.gibbys_bundle_product_form_id").forEach(function (form) {
      form.setAttribute("action", "/cart/add.js");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", excludeBundleFormsFromSlideCart);
  } else {
    excludeBundleFormsFromSlideCart();
  }

  // The bundle widget's own submit handler adds the items, then reloads the page
  // and clicks #cart-icon to open the cart. That click runs before Slide Cart has
  // bound its /cart link handler, so it navigates to /cart instead. Handle the
  // submit here (capture phase, ahead of the widget) and open Slide Cart directly.
  function getSelectedBundleItems() {
    if (typeof getSelectedProducts !== "function") return null;
    return getSelectedProducts()
      .filter(function (product) { return product && product.ID; })
      .map(function (product) { return { id: Number(product.ID), quantity: 1 }; });
  }

  function setBundleError(form, message) {
    var container = form.closest("product-form") || form.parentNode;
    var errorMsg = container && container.querySelector(".js-form-error");
    if (!errorMsg) return;
    if (message) errorMsg.textContent = message;
    errorMsg.hidden = !message;
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains("gibbys_bundle_product_form_id")) return;

    var items = getSelectedBundleItems();
    if (!items || !items.length) return; // Fall back to the widget's own handler.

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector('[type="submit"]');
    if (button) {
      if (button.getAttribute("aria-disabled") === "true") return;
      button.setAttribute("aria-disabled", "true");
    }

    setBundleError(form, null);

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || "Could not add bundle to cart.");
        });
      })
      .then(function () {
        if (typeof window.SLIDECART_UPDATE === "function" && typeof window.SLIDECART_OPEN === "function") {
          window.SLIDECART_UPDATE(function () { window.SLIDECART_OPEN(); });
        } else {
          window.location.href = root + "cart";
        }
        refreshCartBubble();
      })
      .catch(function (error) { setBundleError(form, error.message); })
      .then(function () { if (button) button.removeAttribute("aria-disabled"); });
  }, true);
})();